import { Component, Input, OnInit,ChangeDetectorRef } from '@angular/core'
import { MatSnackBar } from "@angular/material"
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'

import { DialogService, StateService,VisiteService,DocumentService } from '../../../../../services'

//import { ChoiceCourrierComponent } from "../../../layout/dialogs/choice-courrier-dialog/choice-courrier.component"
//import { CourrierDialog } from "../../../layout/dialogs/courrier-dialog/courrier-dialog.component"
import { LoadDialogComponent } from '../../../layout/dialogs/load-dialog/load.component'
import { ConfirmComponent } from '../../../layout/dialogs/confirm-dialog/confirm.component'

import { UploadFileDialogComponent } from '../../../layout/dialogs/upload-file-dialog/upload-file-dialog.component'

import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { of,Observable, Subject  } from 'rxjs'

const KEY = 'dossier-rdv-document'

@Component({
  selector: 'atyl-dossier-rdv-document',
  templateUrl: './dossier-rdv-document.component.html',
  styleUrls: ['./dossier-rdv-document.component.scss']
})
@Stringable({
  path: 'views/partials/content/dossier/dossier-rdv-document',
  key: KEY,
})
export class DossierRdvDocumentComponent implements OnInit {

 @Input() eventLoad: Observable<boolean>;
  expanded: boolean = true;
  @Input() documents: any[] = [];
  @Input() tiers: any
  @Input() visite: any
  @StringableValues(KEY) strings: any

  user:any;
  
  constructor(
	private stateService: StateService,
	private dialogService: DialogService,
	private documentService: DocumentService,
	private visiteService:  VisiteService,
	private changeDetectorRef: ChangeDetectorRef,
	private snackBar: MatSnackBar
		
  ) { }

  ngOnInit() {
	console.log("DossierRdvDocumentComponent init",this.tiers,this.visite,this.eventLoad)
	if (this.eventLoad!=undefined)
		this.eventLoad.subscribe((loading:boolean) => {
			console.log("DossierRdvDocumentComponent init load",loading);
				if (loading)  {
					this._loadDoc();
				}
		});
	
	this.stateService.user.subscribe((user) => {
	        if (user) {
	            this.user = user;
	            console.log("DossierRdvCourrierComponent user",this.user);
	           
	        }

	    })	
		
  }
  
  _loadDoc() {
	this.documents=[];
	
	let _opts:any={
		visite:this.visite,
		consultation: this.visite.consultation
	}
	console.log("DossierRdvDocumentComponent _loadDoc",_opts);
	this.visiteService.getDocumentList(this.visite.ID,_opts).subscribe((res: JSONRpcResponse) => {
				console.log("DossierRdvCourrierComponent _loadCourrier",_opts,res);
				
				if (res.result) {
					
					this.documents=res.result;
					this.changeDetectorRef.detectChanges();
				}
	});
  }
  
  
  addDocument(documents: any)
     {
  		
  		let instruction:any={
			demande: {
				type: {
					ID:'SEANCE'
				}	
			}
		}
		
  		const dialogRef = this.dialogService.open(UploadFileDialogComponent,{
  			data: {
  				instruction: instruction
  					
  			},
			height: "80vh",
	           width: "45vw",
	           draggable: true,
	           resizable: true,
	           minimizable: true,
	           maximizable: true,
  		});
  		dialogRef.afterClosed().subscribe(result => {
  			if (result != undefined && result != "") {
  				let document: any = {
  					ID: 0,
  					demandeid: 0,
  					document: result.selectedDocument.document,
  					value: result.selectedDocument.value,
  					desciption: null,
  					status: result.currentEtat,
  					parameter: result.selectedDocument.parameter,
  					GED: result.GED,
  					formulaires: result.selectedFormulaires
  				}
  				document.value.parameter = result.selectedDocument.parameter

  				if (result.selectedDocument.description)
  					document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;
  				
  				if (result.selectedDocument.demandeID) {
                      document.demandeid = result.selectedDocument.demandeID;
                  }

  				console.log("before document", document,document.demandeid, document, this.tiers.dossierID,instruction.demande.type.ID)
  				this.documentService.setDocumentByInstruction(
  					document.demandeid, document, this.tiers.dossierID,instruction.demande.type.ID,this.visite.ID,this.visite.consultation.ID)
  				.subscribe((res: JSONRpcResponse) => {
  					console.log("after document", res)
  					if (res.error) {
  										
  										let mess:string=(res.error.data!=undefined) ? res.error.data : "Erreur importation document";
  										this.snackBar.open(mess, '', {
  																		duration: 2500,
  																		panelClass: ['error-snackbar']
  																	});
  									}
  											else {
  								this._loadDoc();
  							} 
  					})
					
  			}
  		});
  	}
      
     
	uploadeDialog(document:any, editable = true) {
			console.log("uploadeDialog",document,editable)
			if (document.ged)
				editable = false;

			
			let instruction:any={
				        ID: document.instructionID,
						demande: {
							ID: document.demandeID,
							type: {
								ID: 'SEANCE'
							}	
						}
					}
			
			const dialogRef = this.dialogService.open(UploadFileDialogComponent,{
				data: {
					instruction: instruction,
					document: document,
					isEditable: editable
					/*documents: this.allDocumentsDossier,
					isEditable: editable && this.updDossier && (document.all_rights || document.readAndWrite ? true : false),
					droits: this.droits*/
				},
				width:"30vw"
			});
			dialogRef.afterClosed().subscribe(result => {
				if(result && result != ""){
					let dct: any = {
						ID: document.ID,
						demandeid:  instruction.demande.ID,
						document: result.selectedDocument.document,
						value: result.selectedDocument.value,
						desciption: null,
						status: result.currentEtat,
						parameter: result.selectedDocument.parameter,
						GED: result.GED,
						formulaires: result.selectedFormulaires
					}
					document.value.parameter = result.selectedDocument.parameter
					document.GED = result.GED;
					
					if (result.selectedDocument.description)
						document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;
			
					/*document.value = result.selectedDocument.value;
					document.value.parameter = result.selectedDocument.parameter;
					document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;
					document.value.archive = JSON.parse(result.archive);
					document.status = result.currentEtat;*/
					console.log("setDocumentByInstruction",document.demandeid, document, this.tiers.dossierID, instruction.demande.type.ID,this.visite.ID,this.visite.consultation.ID)
					
					this.documentService.setDocumentByInstruction(instruction.demande.ID, document, this.tiers.dossierID, instruction.demande.type.ID,this.visite.ID,this.visite.consultation.ID).subscribe((res: JSONRpcResponse) => {
						console.log("after document", res)
						if (res.error) {
																
									let mess:string=(res.error.data!=undefined) ? res.error.data : "Erreur importation document";
									this.snackBar.open(mess, '', {
																	duration: 2500,
																	panelClass: ['error-snackbar']
																});
								}
						else {
							this._loadDoc();
						}
					})
					/*(document.demandeid ? document.demandeid : this.currentInstru.demande.ID, document).subscribe((res) => {
					//this.reloadDossier();
						this.isLoadInstruction=false;
						this.tabInstructionLoad();
						});*/
				}
			});
		}
	
	  
	  	download(url: string) {
	           //  window.open(url,' _blank');
	  		const dial=this.dialogService.open(LoadDialogComponent, {
	  				               data: {
	  				                   url: url
	  				               },
	  							   height: "95vh",
	  							   width: "80%",
	  							   minimizable: true,
	  							   maximizable: true,
	  							   draggable: true,
	  				           }, (res: any) => {
	  				               
	  				           })
	  }
	  
	  deleteDocument(demandeDoc: any) {
	          if (demandeDoc) {
	              this.dialogService.open(ConfirmComponent, {
	                  data: {
	                      libelle: this.strings.confirmMessages.deleteCourrier
	                  },
	                  draggable: true,
	              }, (res: any) => {
	                  if (res && res === 'true') {
	                      this.documentService.setDocumentDelete(demandeDoc.ID).subscribe((forms: JSONRpcResponse) => {
	                          this._loadDoc();
	                      })
	                  }
	              })
	          }
	      }

      restoreDocument(demandeDoc: any) {
          if (demandeDoc) {
              this.dialogService.open(ConfirmComponent, {
                  data: {
                      libelle: this.strings.confirmMessages.restoreCourrier
                  },
                  draggable: true,
              }, (res: any) => {
                  if (res && res === 'true') {
                      this.documentService.setDocumentRestore(demandeDoc.ID).subscribe((forms: JSONRpcResponse) => {
                          this._loadDoc();
                      })
                  }
              })
          }
      }
	  
	  
	  
	 

}
